import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function Account({ children }: Props) {
  return (
    <div className="fixed flex gap-3 xxl:gap-5 inset-x-[--boundary-offset-x] inset-y-[--boundary-offset-y]">
      {children}
    </div>
  );
}
